/**
 * Claude 素色 ECharts 主题（charts/ 标准入口）
 *
 * 源主题对象在 `@/styles/claude-chart-theme`，本文件作为
 * `apps/web-app/src/components/charts/` 的标准导出位置，方便：
 *   1. 图表组件就近 import：`import { claudeMonoTheme } from '@/components/charts/theme'`
 *   2. 测试覆盖：`apps/web-app/src/components/charts/__tests__/theme.spec.ts`
 *   3. 全站统一通过 `registerTheme.ts` 注册到 ECharts 全局
 *
 * 设计原则（Claude Code 素色）：
 *   - 主色阶：墨黑 → 灰阶 → 赤陶橙
 *   - 多色对比图最多 2 色（墨黑 + 橙）
 *   - sequential palette 用同色不同明度
 *   - 字体：JetBrains Mono / Geist Mono / Inter
 */

import {
  claudeMonoTheme as sourceTheme,
  CLAUDE_PALETTE,
  CLAUDE_SEQUENTIAL,
  CLAUDE_DUAL,
  CLAUDE_THEME_NAME,
} from '@/styles/claude-chart-theme'

/** ECharts 主题名（全局注册后使用） */
export const CLAUDE_THEME = CLAUDE_THEME_NAME

/**
 * Claude 素色 ECharts 主题对象。
 *
 * 通过 `echarts.registerTheme(CLAUDE_THEME, claudeMonoTheme)` 注册后，
 * 任何图表 `init(el, CLAUDE_THEME)` 或 `<v-chart :theme="CLAUDE_THEME">` 即可继承。
 */
export const claudeMonoTheme = sourceTheme

/** 主色阶 7 色（墨黑 + 赤陶橙 + 灰阶 + 苔绿/砖红/灰蓝/灰紫） */
export { CLAUDE_PALETTE }

/** 单色阶 sequential（热力图/区间图/渐变） */
export { CLAUDE_SEQUENTIAL }

/** 对比双色（实际 vs 预测、正常 vs 异常） */
export { CLAUDE_DUAL }
